/*
  TODO: Lighthouse scores are dropping due to authentication
  features. Disabling these features for now
*/
import { initializeApp } from 'firebase/app';
//
import {
  addDoc,
  collection,
  doc,
  getDocs,
  getFirestore,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  where,
} from 'firebase/firestore';

// Client SDK
const firebaseClientConfig = {
  apiKey: process.env.GATSBY_FIREBASE_CHDORG_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_CHDORG_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_CHDORG_PROJECT_ID,
  storageBucket: process.env.FIREBASE_CHDORG_STORAGE_BUCKET,
  messageSenderId: process.env.FIREBASE_CHDORG_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_CHDORG_APP_ID,
};

const firebaseAppClient: any = initializeApp(firebaseClientConfig);
const dbClient = getFirestore(firebaseAppClient);

export {
  addDoc,
  dbClient,
  collection,
  doc,
  firebaseAppClient,
  getDocs,
  limit,
  query,
  onSnapshot,
  orderBy,
  serverTimestamp,
  where,
};
